import React from 'react';
var VeltCommentDialogOptionsDropdownContentNotificationSubscribeWireframe = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-dialog-options-dropdown-content-notification-subscribe-wireframe", null, children));
};
export default VeltCommentDialogOptionsDropdownContentNotificationSubscribeWireframe;
